'use strict';

import React, { Component } from 'react';
import $ from 'jquery';
import { ListItem, ListItemText, ListItemIcon, Typography, Button } from '@material-ui/core';
import { Close, AccountCircle, Create } from '@material-ui/icons';

class ProfileAboutItemQuote extends Component{
    state = {
        error: '',
        styleError: {
            color: 'white'
        },

        info: '',
        values: {},
    }
        
    componentDidMount() {
        this.getOtherInfo()
    }
    getOtherInfo() {   
        var methodName = 'Get Other info';
        // var idInfo = this.props.userId;
        // if (idInfo === ''){
        //     idInfo = this.props.boxId;
        // }

        var urlBoxFreeOfAssociation = "/userinfo/info/all?boxAssoID=" + this.props.boxAssoId +"&info=quote";

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            let info = '';
            try {
                var data = result; //var data = JSON.parse(result);
                info = data.info;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                info: info,
                values: info
            });
        }.bind(this));
      
    }
    render() {
        console.log('[DEBUG], Prospect USER , quote : ', this.state.info);

        let kit = this.state.info ? this.state.info.KitName : ""

        return (
            <div>
                { this.state.info && this.state.info !== "nullerr" &&
                    <div>
                        <ListItem button>
                            <ListItemIcon>
                                <AccountCircle />
                            </ListItemIcon>
                            <ListItemText>
                                <Typography variant="h4">Quotation Info</Typography>
                            </ListItemText>
                        </ListItem>
                        <div className="pmbb-body p-l-30">
                            <div className="pmbb-view">
                                {kit}
                                {this.state.info.info.map( (e) => (
                                <dl className="dl-horizontal">
                                    <dt>Equipement : {e.Equipement}</dt>
                                    <dd className="row"><div className="col-xs-8">Nombre : {e.Nombre}</div></dd>
                                    <dd className="row"><div className="col-xs-8">Puissance :{e.Puissance}</div></dd>
                                    <dd className="row"><div className="col-xs-8">Temps Utilisation : {e.usageTime}</div></dd>
                                </dl>

                                ) )  }
                            </div>
                        </div>

                    </div>
                }
            </div>

        )
    }
};

export default ProfileAboutItemQuote

